import { createReducer, on } from '@ngrx/store';

import { close, open, toggle, toggleItem } from '../actions/sidebar.actions';

export const sidebarFeatureKey = 'sidebar';

export interface SidebarState {
  open: boolean;
  menuState: { [key: string]: boolean };
}

export const initialState: SidebarState = {
  open: false,
  menuState: {
    'learner-menu': true,
    'training-manager-menu': true,
    'author-menu': true,
    'vendor-menu': true,
    'tools-menu': true
  }
};

const reducer = createReducer(
  initialState,
  on(open, (state) => ({ ...state, open: true })),
  on(close, (state) => ({ ...state, open: false })),
  on(toggle, (state) => ({ ...state, open: !state.open })),
  on(toggleItem, (state, { item }) => ({ ...state, menuState: { ...state.menuState, ...item } }))
);

export function sidebarReducer(state, action): SidebarState {
  return reducer(state, action);
}
